import { Constructor } from '@angular/cdk/table';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IImgMediaDto } from 'src/app/core/dtos/interfaces/i-img-media-dto';
import { compareArrays } from '../utils/array-utils';
type WithSponsorLogosFormSectionType = {
  _initSponsorLogos(sponsorLogos: IImgMediaDto[]): void;
  _initSponsorLogosValueChanges(
    getPreviousSponsorLogosValue: () => IImgMediaDto[] | null
  ): void;
  _buildSponsorLogos(): IImgMediaDto[];
};
type SponsorLogosFormSectionRequirementsBase = {
  form: FormGroup;
  FORM_PATHS: {
    SPONSOR_LOGOS: () => string;
  };
  destroy$: Subject<boolean>;
};
export function WithSponsorLogosFormSection<
  TBase extends Constructor<SponsorLogosFormSectionRequirementsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithSponsorLogosFormSectionType;
  prototype: WithSponsorLogosFormSectionType;
} & TBase {
  return class WithSponsorLogosFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }
    _initSponsorLogos(sponsorLogos: IImgMediaDto[]): void {
      let sponsorLogosControl = this.form.get(
        this.FORM_PATHS.SPONSOR_LOGOS()
      ) as FormArray<FormControl<IImgMediaDto>>;
      if (sponsorLogos) {
        sponsorLogos.forEach((i) => {
          sponsorLogosControl.push(new FormControl(i));
        });
      }
    }
    _initSponsorLogosValueChanges(
      getPreviousSponsorLogosValue: () => IImgMediaDto[] | null
    ): void {
      this.form
        .get(this.FORM_PATHS.SPONSOR_LOGOS())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (compareArrays(newValue, [getPreviousSponsorLogosValue()])) {
              this.form.get(this.FORM_PATHS.SPONSOR_LOGOS()).markAsPristine();
            } else {
              this.form.get(this.FORM_PATHS.SPONSOR_LOGOS()).markAsDirty();
            }
          },
        });
    }
    _buildSponsorLogos(): IImgMediaDto[] {
      return this.form.get(this.FORM_PATHS.SPONSOR_LOGOS()).value;
    }
  };
}
